import { render, staticRenderFns } from "./CheckGiftCard.vue?vue&type=template&id=587e4aa2&scoped=true"
import script from "./CheckGiftCard.vue?vue&type=script&lang=js"
export * from "./CheckGiftCard.vue?vue&type=script&lang=js"
import style0 from "./CheckGiftCard.vue?vue&type=style&index=0&id=587e4aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e4aa2",
  null
  
)

export default component.exports